import React from "react";
import sampleVideo from "./Cloudimages/01_SNOWLAND_30SEC FINAL OUTPUT.mp4";
import img2 from "../../../images/aaaservices/MAHENDRA1.jpg";
const Grocerycardsdata = () => {
    return (
        <>
            <style>{`
        .food-banner2 {
          display: flex;
          flex-direction: column;ss
          align-items: center;
          background: #4e1f5cff;
          border-radius: 10px;
          color: #fff;
          padding: 40px 5%;
        }

        /* Top Heading */
        .top-section2 {
          text-align: center;
          margin-bottom: 50px;
          max-width: 800px;
        }

        .top-section2 h2 {
          font-size: 2.8rem;
          margin-bottom: 15px;
          font-weight: bold;
        }

        .top-section2 p {
          font-size: 1.1rem;
          line-height: 1.6;
          color: #f0f0f0;
        }

        /* Banner Content */
        .banner-content2 {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          flex-wrap: wrap;
          width: 100%;
          gap: 30px;
        }

        /* Left Section */
        .banner-left2 {
          flex: 1 1 300px;
          max-width: 600px;
        }

        .banner-left2 h1 {
          font-size: 2.8rem;
          font-weight: bold;
          line-height: 1.3;
          margin-bottom: 20px;
        }

        .banner-left2 p {
          font-size: 1rem;
          line-height: 1.6;
          margin-bottom: 25px;
        }

        /* Right Section (Video) */
        .banner-right2 {
          flex: 1 1 300px;
          max-width: 600px;
          text-align: center;
        }

        .video-box2 {
          width: 100%;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 6px 20px rgba(0,0,0,0.3);
        }

        .video-box2 video {
          width: 100%;
          height: auto;
          display: block;
        }

        /* Responsive */
        @media (max-width: 1024px) {
          .top-section2 h2 {
            font-size: 2.2rem;
          }
          .banner-left2 h1 {
            font-size: 2.2rem;
          }
        }

        @media (max-width: 768px) {
          .banner-content2 {
            flex-direction: column;
            align-items: center;
          }

          .banner-left2,
          .banner-right2 {
            max-width: 100%;
          }

          .banner-left2 h1 {
            font-size: 2rem;
          }

          .banner-left2 p {
            font-size: 0.95rem;
          }
        }

        @media (max-width: 480px) {
          .food-banner2 {
            padding: 30px 3%;
          }

          .banner-left2 h1 {
            font-size: 1.6rem;
          }

          .banner-left2 p {
            font-size: 0.9rem;
          }

          .video-box2 {
            width: 100%;
          }
        }
      `}</style>

            <div className="food-banner2">
                {/* Optional Top Section */}
                <div className="top-section2">
                    <h1>
                        Logistics & Services
                    </h1>

                </div>

                {/* Banner Content */}
                <div className="banner-content2">
                    {/* Left Section */}
                    <div className="banner-left2">

                        <p>
                            Efficient, reliable, and timely logistics solutions to keep your
                            business moving forward. We ensure smooth operations for every delivery.


                        </p><br></br>
                        <p>
                            Efficient, reliable, and timely logistics solutions to keep your
                            business moving forward. We ensure smooth operations for every delivery.
                        </p>
                    </div>

                    {/* Right Section (Video) */}
                    <div className="banner-right2">
                        <div >
                            <img src={img2} style={{ height: "350px" }} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Grocerycardsdata;
